// extracted by mini-css-extract-plugin
module.exports = {"page":"page__2UuRD","body":"body__P6MEa"};